import React, {
  createContext, useState, useMemo, useEffect, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { shallowEqual } from 'react-redux';
import { useSafeContext } from 'utils/hooks/useSafeContext';

export const QuestionnaireContext = createContext(null);

export const useQuestionnaireData = () => {
  const { data } = useSafeContext(QuestionnaireContext);
  return data;
};

export const useUpdateQuestionnaireData = () => {
  const { setData } = useSafeContext(QuestionnaireContext);
  return setData;
};

const KeepQuestionnaireContextSync = ({ value }) => {
  const setData = useUpdateQuestionnaireData();
  const prevValueRef = useRef();

  useEffect(() => {
    const { current: prevValue } = prevValueRef;
    prevValueRef.current = value;
    if (!prevValue || shallowEqual(prevValue, value)) {
      return;
    }
    setData(value);
  }, [value, setData]);

  return null;
};

KeepQuestionnaireContextSync.propTypes = {
  value: PropTypes.object,
};

export const QuestionnaireProvider = ({ children, value: valueProp = {} }) => {
  const [data, setData] = useState(valueProp);
  const value = useMemo(() => ({ data, setData }), [data, setData]);
  return (
    <QuestionnaireContext.Provider value={value}>
      <KeepQuestionnaireContextSync value={valueProp} />
      {children}
    </QuestionnaireContext.Provider>
  );
};

QuestionnaireProvider.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.object,
};
